export const USER_PROFILE_YATS_CACHE = 'USER_PROFILE_YATS_CACHE';

import { useQuery } from '@tanstack/react-query';

import { useAppSelector } from '@pkg/hooks';

import { callGetUserYats } from './request';

export function useProfileYats() {
    const userId = useAppSelector((state) => state.yatPage.user_id);
    return useQuery({
        queryKey: [USER_PROFILE_YATS_CACHE, userId],
        queryFn: ({ signal }) =>
            callGetUserYats({
                settings: { signal },
                variables: {
                    userFilter: { id: userId },
                },
            }),
        enabled: !!userId,
        staleTime: Infinity,
    });
}
